import { Button } from "reactstrap";
import AppSpinner from "../../elements/AppSpinner";
import { Modal } from "rsuite";

const AppModal = ({
  open,
  onClose,
  title,
  content,
  cancelButtonText = "Close",
  confirmButtonText = "Update",
  onConfirm,
  submitting = false,
  disabled,
  keyboard = true,
  backdrop = true,
  size = "sm",
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      keyboard={keyboard}
      backdrop={backdrop}
      size={size}
    >
      <div className="modal-header">
        <h5 className="modal-title" id="exampleModalLabel">
          {title}
        </h5>
        <button
          aria-label="Close"
          className="close"
          data-dismiss="modal"
          type="button"
          onClick={onClose}
        >
          <span aria-hidden={true}>×</span>
        </button>
      </div>
      <div
        className="modal-body pb-2"
        style={{ maxHeight: "calc(100vh - 200px)", overflowY: "auto" }}
      >
        {content}
      </div>
      <div className="modal-footer pt-2">
        <Button
          color="secondary"
          data-dismiss="modal"
          type="button"
          onClick={onClose}
        >
          {cancelButtonText}
        </Button>
        {onConfirm && (
          <Button
            color="primary"
            type="submit"
            disabled={submitting || disabled}
            onClick={onConfirm}
          >
            {submitting ? (
              <AppSpinner size="sm" color="white" />
            ) : (
              confirmButtonText
            )}
          </Button>
        )}
      </div>
    </Modal>
  );
};

export default AppModal;
